import React from 'react'
import { Field } from 'react-final-form'
import type { FieldValidator } from 'final-form'
import { getValidateFunction } from '@/utils/validators'
import CheckboxFieldView from './CheckboxFieldView'
import type { ICheckboxProps, TCheckboxViewProps } from './interfaces'

// Не использовать другой, ломается сообщение об ошибке
const isCheckboxRequired: FieldValidator<boolean> = value => (value ? undefined : 'required')

const CheckboxInput: React.FC<ICheckboxProps> = props => {
  const { isRequired, customValidator } = props

  const validate = getValidateFunction(() => {
    const validators: FieldValidator<boolean>[] = []
    if (isRequired) validators.push(isCheckboxRequired)
    if (customValidator) validators.push(customValidator)

    return validators
  }) as FieldValidator<boolean>

  return (
    <Field<boolean> validate={validate} type="checkbox" {...props}>
      {(fieldProps: TCheckboxViewProps) => <CheckboxFieldView {...fieldProps} {...props} />}
    </Field>
  )
}

export default CheckboxInput
